





































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/left-nav.vue";
import Show from "../../components/show.vue";
import Literature from "../../components/literature.vue";
import { GetCenter } from "@/request/idr";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Show,
    Literature,
  },
})
export default class Shezhen extends Vue {
  private get user() {
    return this.$store.state.user;
  }
  private activeType = "首页";
  private type = "文献";
  private searchText = "";
  private handleSelect(key, keyPath) {
    this.activeType = key;
  }
  /**
   * @description 搜索
   */
  private search() {
    this.activeType = "文献";
    (this.$refs.show as any).getList(1);
    (this.$refs.literature as any).getList(1);
  }
  /**
   * @description 初始化
   */
}
